export default {
  SET_CURRENT_CLASS_ATTENDANCE(state, payload) {
    state.currentClassAttendance.time = payload.time
    state.currentClassAttendance.date = payload.date
    // state.currentClassAttendance.subject = payload.subject
    // state.currentClassAttendance.class = payload.class
  },
}
